import { API_ROUTES, apiPost } from "@configure/apiConfig";

// Updated updateStatus function
export const updateAllocationStatus = async (header, payload) => {
    try {
        const response = await apiPost(API_ROUTES.UPDATE_ALLOCATION_STATUS, payload, null, header);
        return response?.data;
    } catch (error) {
        console.error("Update failed", error);
        return null;
    }
};
